import React from "react";
import MachineStatus from "components/MachineStatus/MachineStatus";
import { PlantItem } from "components/StyledComponents";

// Display only. The actuator status subscription now lives in the Admin layout
// (ActuatorStatusSubscribersHost) so it survives navigation instead of dying on
// remount — the @absinthe/socket resubscribe race used to leave actuator status
// stuck after a tab switch. The status shown here comes from props, fed by the
// cache-backed PLANT_LOCATIONS query that the hoisted subscription patches.
const ActuatorSubscription = ({
  automationStatus,
  id,
  name,
  status,
  type,
  maintenanceMode,
}) => (
  <PlantItem>
    <MachineStatus
      automationStatus={automationStatus}
      status={status}
      actuatorName={name}
      id={id}
      type={type}
      maintenanceMode={maintenanceMode}
    />
  </PlantItem>
);

export default ActuatorSubscription;
